import { lookupService } from '../../helpers/services/lookup.service';
import i18n from '@/i18n'
import { sharedHelper } from '@/utils'

export const state = {
  roleDdl: [],
  permissionDdl: [],
  userDdl: [],
  companyDdl: [],
  formDdl: [],
  classDdl: [],
  moaDdl: [],
  typeDdl: [],
  purposeDdl: [],
  brandDdl: [],
  statusDdl: [],
  productDdl: [],
  aiDdl: [],
  sourceDdl: [],
};

export const LOOKUP_MODULE = "lookup";

// define action 
export const LOOKUP_ROLE = 'lookupRole';
export const LOOKUP_PERMISSION = 'lookupPermission';
export const LOOKUP_COMPANY = 'lookupCompany';
export const LOOKUP_FORM = 'lookupForm';
export const LOOKUP_CLASS = 'lookupClass';
export const LOOKUP_MOA = 'lookupMOA';
export const LOOKUP_TYPE = 'lookupType';
export const LOOKUP_PURPOSE = 'lookupPurpose';
export const LOOKUP_BRAND = 'lookupBrand';
export const LOOKUP_STATUS = 'lookupStatus';
export const LOOKUP_USER = 'lookupUser';
export const LOOKUP_PRODUCTS = 'lookupProduct';
export const LOOKUP_AIS = 'lookupAI';
export const LOOKUP_SOURCES = 'lookupSource';
export const LOOKUP_PRODUCT_CREATE_UPDATES = 'lookupProductgetLookupProductCreateUpdates';

// define mutation
const ROLE_LOOKUP = "roleLookup";
const PERMISSION_LOOKUP = "permissionLookup";
const USER_LOOKUP = "userLookup";
const COMPANY_LOOKUP = "userLookup";
const FORM_LOOKUP = "formLookup";
const CLASS_LOOKUP = "classLookup";
const MOA_LOOKUP = "moaLookup";
const TYPE_LOOKUP = "typeLookup";
const PURPOSE_LOOKUP = "purposeLookup";
const BRAND_LOOKUP = "brandLookup";
const STATUS_LOOKUP = "statusLookup";
const PRODUCT_LOOKUP = "productLookup";
const AI_LOOKUP = "AILookup";
const SOURCE_LOOKUP = "SourceLookup";
const PRODUCT_CREATE_UPDATE_LOOKUP = "productCreateUpdateLookup";

export const mutations = {

  [SOURCE_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.sourceDdl = p
    } else {
      state.sourceDdl = []
    }
  },

  [PRODUCT_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.productDdl = p
    } else {
      state.productDdl = []
    }
  },

  [AI_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.aiDdl = p
    } else {
      state.aiDdl = []
    }
  },

  [ROLE_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.value,
          text: x.name
        })
      })

      state.roleDdl = p
    } else {
      state.roleDdl = []
    }
  },

  [USER_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.userDdl = p
    } else {
      state.userDdl = []
    }
  },

  [COMPANY_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.companyDdl = p
    } else {
      state.companyDdl = []
    }
  },


  [FORM_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.formDdl = p
    } else {
      state.formDdl = []
    }
  },


  [CLASS_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.classDdl = p
    } else {
      state.classDdl = []
    }
  },

  [MOA_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.moaDdl = p
    } else {
      state.moaDdl = []
    }
  },


  [TYPE_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.typeDdl = p
    } else {
      state.typeDdl = []
    }
  },


  [PURPOSE_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.purposeDdl = p
    } else {
      state.purposeDdl = []
    }
  },


  [BRAND_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.brandDdl = p
    } else {
      state.brandDdl = []
    }
  },


  // eslint-disable-next-line no-unused-vars
  [PERMISSION_LOOKUP](state, { data, hasOptionAll }) {

    function getCodeAndLabelFromPermission(permission) {
      return {
        code: permission.code,
        label: permission.name,
      }
    }

    state.permissionDdl = data.data.map((permissionModule) => {
      return {
        module: permissionModule.module,
        submodule: permissionModule.submodule,
        permissions: permissionModule.permissions.map(getCodeAndLabelFromPermission)
      }
    })
  },

  // eslint-disable-next-line no-unused-vars
  [STATUS_LOOKUP](state, { data, hasOptionAll }) {

    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.statusDdl = p
    } else {
      state.statusDdl = []
    }
  },

  modulePermissionLookup(state, { data }) {
    function getCodeAndLabelFromPermission(permission) {
      return {
        code: permission.code,
        label: i18n.t(`permissions.${permission.code}`)
      }
    }

    state.permissionDdl = data.data.map((permissionModule) => {
      return {
        module: permissionModule.module,
        submodule: permissionModule.submodule,
        permissions: permissionModule.permissions.map(getCodeAndLabelFromPermission)
      }
    })
  },

  [PRODUCT_CREATE_UPDATE_LOOKUP](state, { data }) {
    let brands = []
    let classes = []
    let companies = []
    let forms = []
    let moas = []
    let purposes = []
    let types = []
    let statuses = []
    let response = data

    if (response.success) {
      response.data.brands.forEach((x) => {
        brands.push({
          value: x.uuid,
          text: x.name
        })
      })

      response.data.classes.forEach((x) => {
        classes.push({
          value: x.uuid,
          text: x.name
        })
      })

      response.data.companies.forEach((x) => {
        companies.push({
          value: x.uuid,
          text: x.name
        })
      })

      response.data.forms.forEach((x) => {
        forms.push({
          value: x.uuid,
          text: x.name
        })
      })

      response.data.moas.forEach((x) => {
        moas.push({
          value: x.uuid,
          text: x.name
        })
      })

      response.data.purposes.forEach((x) => {
        purposes.push({
          value: x.uuid,
          text: x.name
        })
      })

      response.data.types.forEach((x) => {
        types.push({
          value: x.uuid,
          text: x.name
        })
      })

      response.data.status.forEach((x) => {
        statuses.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.brandDdl = brands
      state.classDdl = classes
      state.companyDdl = companies
      state.formDdl = forms
      state.moaDdl = moas
      state.purposeDdl = purposes
      state.typeDdl = types
      state.statusDdl = statuses

    } else {
      state.brandDdl = []
      state.classDdl = []
      state.companyDdl = []
      state.formDdl = []
      state.moaDdl = []
      state.purposeDdl = []
      state.typeDdl = []
      state.statusDdl = []
    }
  },


};

export const actions = {

  [LOOKUP_ROLE]({ commit }, { hasOptionAll }) {
    lookupService.getLookupRoles().then(
      (data) => {
        commit(ROLE_LOOKUP, { data })
      },
      (error) => {
        let message = 'Role Lookup' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(ROLE_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_SOURCES]({ commit }, { hasOptionAll }) {
    lookupService.getLookupSources().then(
      (data) => {
        commit(SOURCE_LOOKUP, { data })
      },
      (error) => {
        let message = 'Source Lookup' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(SOURCE_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_COMPANY]({ commit }, { hasOptionAll }) {
    lookupService.getLookupCompanies().then(
      (data) => {
        commit(COMPANY_LOOKUP, { data })
      },
      (error) => {
        let message = 'Company Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(COMPANY_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_PERMISSION]({ commit }, { hasOptionAll }) {
    lookupService.getAllModulePermissions().then(
      (data) => {
        commit(PERMISSION_LOOKUP, { data, hasOptionAll })
      },
      (error) => {
        let message = 'Permission Lookup' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(PERMISSION_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_FORM]({ commit }, { hasOptionAll }) {
    lookupService.getLookupForms().then(
      (data) => {
        commit(FORM_LOOKUP, { data, hasOptionAll })
      },
      (error) => {
        let message = 'Form Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(FORM_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_USER]({ commit }, { hasOptionAll }) {
    lookupService.getLookupUsers().then(
      (data) => {
        commit(USER_LOOKUP, { data })
      },
      (error) => {
        let message = 'User Lookup' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(USER_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_CLASS]({ commit }, { hasOptionAll }) {
    lookupService.getLookupClasses().then(
      (data) => {
        commit(CLASS_LOOKUP, { data })
      },
      (error) => {
        let message = 'Class Lookup' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(CLASS_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_MOA]({ commit }, { hasOptionAll }) {
    lookupService.getLookupMoas().then(
      (data) => {
        commit(MOA_LOOKUP, { data })
      },
      (error) => {
        let message = 'MOA Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(MOA_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_TYPE]({ commit }, { hasOptionAll }) {
    lookupService.getLookupTypes().then(
      (data) => {
        commit(TYPE_LOOKUP, { data })
      },
      (error) => {
        let message = 'Type Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(TYPE_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_PURPOSE]({ commit }, { hasOptionAll }) {
    lookupService.getLookupPurposes().then(
      (data) => {
        commit(PURPOSE_LOOKUP, { data })
      },
      (error) => {
        let message = 'Purpose Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(PURPOSE_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  async [LOOKUP_BRAND]({ commit }, { hasOptionAll }) {
    await lookupService.getLookupBrands().then(
      (data) => {
        commit(BRAND_LOOKUP, { data })
      },
      (error) => {
        let message = 'Brand Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(BRAND_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_STATUS]({ commit }, { hasOptionAll }) {
    lookupService.getLookupStatus().then(
      (data) => {
        commit(STATUS_LOOKUP, { data })
      },
      (error) => {
        let message = 'Status Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(STATUS_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  async [LOOKUP_PRODUCTS]({ commit }, { hasOptionAll }) {
    await lookupService.getLookupProducts().then(
      (data) => {
        commit(PRODUCT_LOOKUP, { data })
      },
      (error) => {
        let message = 'product Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(PRODUCT_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_AIS]({ commit }, { hasOptionAll }) {
    lookupService.getLookupAIs().then(
      (data) => {
        commit(AI_LOOKUP, { data })
      },
      (error) => {
        let message = 'AI Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(AI_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_PRODUCT_CREATE_UPDATES]({ commit }, { hasOptionAll }) {
    lookupService.getLookupProductCreateUpdates().then(
      (data) => {
        commit(PRODUCT_CREATE_UPDATE_LOOKUP, { data })
      },
      (error) => {
        let message = 'Product Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(PRODUCT_CREATE_UPDATE_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  // eslint-disable-next-line no-unused-vars
  getPermissionModuleLookup({ commit, dispatch }, { hasOptionAll }) {
    lookupService.getAllModulePermissions().then(
      (data) => {
        commit('modulePermissionLookup', { data, hasOptionAll })
      },
      (error) => {
        commit('modulePermissionLookup', { error, hasOptionAll })
      }
    )
  },
};
